/**
 * The operator vocabulary of the lead-list filters and the shape of one filter definition. Kept out
 * of general-filter.ts (file-length cap), which re-exports both, so its importers keep one import.
 */
export type IFilterType =
	| "dropdownCustom"
	| "dropdownCustomExclude"
	| "dropdown"
	| "dropdownExclude"
	| "isEmpty"
	| "isNotEmpty"
	| "isIn"
	| "isNotIn"
	| "textContains"
	| "textDoesNotContain"
	| "textStartsWith"
	| "textEndsWith"
	| "textIsExactly"
	| "greaterEqual"
	| "lessEqual"
	| "between"
	| "greaterEqualDate"
	| "lessEqualDate"
	| "betweenDate";

export const IFilterTypeAsValues = [
	"dropdownCustom",
	"dropdownCustomExclude",
	"dropdown",
	"dropdownExclude",
	"isEmpty",
	"isNotEmpty",
	"isIn",
	"isNotIn",
	"textContains",
	"textDoesNotContain",
	"textStartsWith",
	"textEndsWith",
	"textIsExactly",
	"greaterEqual",
	"lessEqual",
	"between",
];

export const ITextFilterType = [
	"textContains",
	"textDoesNotContain",
	"textStartsWith",
	"textEndsWith",
	"textIsExactly",
];

export const IBooleanFilterType = ["isEmpty", "isNotEmpty", "isIn", "isNotIn"];

export const INumericFilterType = ["greaterEqual", "lessEqual", "between"];

export const IDateFilterType = ["greaterEqualDate", "lessEqualDate", "betweenDate"];

export interface IFilter {
	name: string;
	filterParam: string;
	subSelectFilterParam?: string;
	filterByType: IFilterType[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	filterByValue: any[];
	customColumnId?: number;
	information?: string;
	group?: string;
	translationKey?: string;
}
